import { InjectionToken, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { getAjsProvider } from '@commons/core/core.provider.ajs';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

export const NG1_HYPPERVISION_SERVICE = new InjectionToken('hypervision');

@NgModule({})
export class HypervisionForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: HypervisionForRootModule) {
    if (parentModule) throw new Error(`[HypervisionForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<HypervisionForRootModule> {
    return {
      ngModule: HypervisionForRootModule,
      providers: [
        getAjsProvider(NG1_HYPPERVISION_SERVICE),

        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.HYPERVISOR,
            type: TileType.STANDARD,
            icon: 'tile_hypervision',
            color: Color.FUCHSIA,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'hypervision',
          multi: true,
        },
      ],
    };
  }
}
